var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionsReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_1781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0976 18.8221C21.0975 18.8218 21.0975 18.8215 21.0974 18.8212C23.2026 17.0272 24.5 14.5771 24.5 11.8752C24.5 6.37557 19.1274 1.91724 12.5 1.91724C5.87258 1.91724 0.5 6.37557 0.5 11.8752C0.5 17.3749 5.87258 21.8332 12.5 21.8332C14.716 21.8332 16.7913 21.3342 18.5727 20.465C18.5728 20.4651 20.5673 22.8416 24.5 21.8332C24.5 21.8332 21.3255 20.4495 21.0976 18.8221Z",
    fill: "#FF6F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43156 11.8752C2.43156 6.64538 7.29006 2.35758 13.4658 1.94939C13.1471 1.92835 12.8251 1.91724 12.4999 1.91724C5.87252 1.91724 0.499939 6.37552 0.499939 11.8752C0.499939 17.3748 5.87252 21.8332 12.4999 21.8332C12.8252 21.8332 13.1474 21.8222 13.4661 21.8011C7.2902 21.393 2.43156 17.1052 2.43156 11.8752Z",
    fill: "#FC5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7102 11.1139C12.9945 11.6735 12.9815 12.0639 12.9815 12.7406C12.9815 12.9879 12.8514 13.2741 12.2137 13.2741C11.6802 13.2741 11.498 13.0789 11.498 12.4023C11.498 11.2831 11.9924 10.7495 12.3698 10.4242C12.7993 10.0598 13.528 9.65641 13.528 8.95371C13.528 8.35511 13.0075 8.0688 12.3568 8.0688C11.0294 8.0688 11.3157 9.0708 10.613 9.0708C10.2616 9.0708 9.83221 8.83657 9.83221 8.329C9.83221 7.6263 10.639 6.58521 12.3959 6.58521C14.0616 6.58521 15.1677 7.50911 15.1677 8.73241C15.1677 9.95571 14.0616 10.8406 13.7102 11.1139ZM13.2287 15.1741C13.2287 15.7076 12.7863 16.1761 12.2267 16.1761C11.6671 16.1761 11.2377 15.7076 11.2377 15.1741C11.2377 14.6275 11.6802 14.1721 12.2267 14.1721C12.7733 14.172 13.2287 14.6275 13.2287 15.1741Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_1781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsReview);
export default __webpack_public_path__ + "static/media/questions_review.33dfc898eef24473a2c2a2d40b811179.svg";
export { ForwardRef as ReactComponent };